import React from "react";
import { Box, Typography, Paper } from "@mui/material";

const RuleFrame = () => {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Rule Frame
      </Typography>
      <Paper elevation={2} sx={{ p: 2 }}>
        <Typography>
          This is the RuleFrame component. Replace this with your actual UI.
        </Typography>
      </Paper>
    </Box>
  );
};

export default RuleFrame;
